/**
 * TanStack Query hooks for `cap-hit-auto-pause`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	capHitAutoPauseQueryKeys,
	type CreateCapHitAutoPauseBody,
	type ListCapHitAutoPauseResponse,
	type CapHitAutoPauseRow,
} from "./api";

export function useCapHitAutoPauseList(): UseQueryResult<ListCapHitAutoPauseResponse, Error> {
	return useQuery({
		queryKey: capHitAutoPauseQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapHitAutoPauseCreate(): UseMutationResult<CapHitAutoPauseRow, Error, CreateCapHitAutoPauseBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capHitAutoPauseQueryKeys.all });
		},
	});
}

export function useCapHitAutoPauseDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capHitAutoPauseQueryKeys.all });
		},
	});
}
